import { z } from "zod";

export const PerformanceCustomerSchema = z.object({
  id: z.string(),
  customerName: z.string(),
  contactName: z.string(),
  contactPhone: z.string().nullable(),
  contactEmail: z.string().nullable(),
  contactAddress: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type PerformanceCustomerDTO = z.infer<typeof PerformanceCustomerSchema>;

export const CustomerLookupItemSchema = z.object({
  id: z.string(),
  /** display label for lookup combobox */
  name: z.string(),
  customerName: z.string(),
  contactName: z.string(),
  contactPhone: z.string().nullable(),
  contactEmail: z.string().nullable(),
  contactAddress: z.string().nullable(),
});
export type CustomerLookupItemDTO = z.infer<typeof CustomerLookupItemSchema>;

export const UpsertPerformanceCustomerInputSchema = z.object({
  customerName: z.string().nullable(),
  contactName: z.string().min(1),
  contactPhone: z.string().nullable().optional(),
  contactEmail: z.string().nullable().optional(),
  contactAddress: z.string().nullable().optional(),
});
export type UpsertPerformanceCustomerInputDTO = z.infer<
  typeof UpsertPerformanceCustomerInputSchema
>;
